import React, { useEffect, useState } from "react";
import Menu from "../components/Navbar";
import axios from 'axios';
import moment from "moment";

const BlogLeftSide = () => {
  const [getBlog, setBlog] = useState([])

  useEffect(async() => {

    const _getBlog = async () => {
      try{
      await axios.get(`https://buharaapi.stechomeyazilim.info:5210/getBlog/select/`)
       .then(res => {
        setBlog(res.data)
       })
     }
     catch (error) {
       
       console.log("errorAS" + error)
     }
  }
  await _getBlog()

    let timer= setTimeout(function () {
      document.querySelector(".loader-wrapper").style = "display: none";
    }, 2000);
    return () =>{ clearTimeout(timer)}
  }, []);
  const [bgImg, setBgImg]= useState({
    backgroundImage:`url(${process.env.PUBLIC_URL}/assets/images/team-img-bg.png)`
  });
  const color= localStorage.getItem("color");
  useEffect(()=>{
    if(color === "color-1")
     setBgImg( {
      backgroundImage:`url(${process.env.PUBLIC_URL}/assets/images/team-img-bg.png)`
    });
    else if(color === "color-2")
    setBgImg({ backgroundImage:`url(${process.env.PUBLIC_URL}/assets/images/color/color-2/team-img-bg.png)`})
    else 
    setBgImg({backgroundImage:`url(${process.env.PUBLIC_URL}/assets/images/color/color-3/team-img-bg.png)`})
  },[color]);

  return (
    <div>
      <Menu />
      {/*blog Section start*/}
      <div className="page-margin">
        {/*breadcrumb start*/}
        <div className="breadcrumb-bg">
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-sm-6 col-text-center d-align-center">
                <h2 className="title">
                  Blog<span> Yazıları</span>
                </h2>
              </div>
              <div className="col-md-6 col-sm-6 col-text-center">
                <nav aria-label="breadcrumb" className="blog-bradcrumb ">
                  <ol className="breadcrumb bg-transparent mb-0">
                    <li className="breadcrumb-item">
                      <a href="/">Anasayfa</a>
                    </li>
                    <li className="breadcrumb-item">
                      <a href="/blog-list">Blog</a>
                    </li>
                    <li className="breadcrumb-item active">
                      <a href="javascript" onClick={(e)=>{e.preventDefault()}}>Blog Yazılarımız</a>
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
        {/*breadcrumb end*/}

        {/*blog Section start*/}
        <section>
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-lg-9 blog-sec">
                <div className="row blog-list">
                { getBlog.map((val, i) => {
                  return (
                  <div className="col-lg-6 col-md-12">
              
                    <div key={i} className="blog-item">
                      <div id="blog-block" className="blog-block" style={bgImg}>
                        <div className="blog-box">
                          <div className="overflow-hidden">
                            <a href="blog-details">
                              <img
                                src={'https://buharasubdomain.stechomeyazilim.info/' + val.Blog_Image}
                                alt="blog"
                                className="img-fluid"
                              />
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="blog-text">
                        <a href="blog-details">
                          <h3>{val.Blog_Title}</h3>
                          <p>
                          {val.Blog_Desc.slice(0,50)} ...
                          </p>
                        </a>
                        <h5>BUhara Baharat</h5>
                      </div>
                    </div> 
                  </div>)})}
              
                
                </div>
              </div>
              {/*sidebar section*/}
              <div className="col-md-4 col-lg-3 order-md-first list-sidebar">
                <div className="sidebar">
                
                
                  <h4 className="blog-title">Son Blog Yazıları</h4>
                  <div className="blog-divider"></div>
                  <div className="recent-blog marg-20">
                  { getBlog.map((val, i) => {
                    return(
                    <div className="media">
                      <img className="mr-3"  style={{height:50,width:50}} src={'https://buharasubdomain.stechomeyazilim.info/' + val.Blog_Image} alt="blog" />
                      <div className="media-body">
                        <a href="blog-details">
                          <h5 className="mt-0">{val.Blog_Title}</h5>
                        </a>
                        <p className="m-0">{moment(val.Created_DateTime).format('DD/MM/YYYY')}</p>
                      </div>
                    </div>)})}

                  </div>
                </div>
              </div>
              {/*sidebar section*/}
            </div>
          </div>
        </section>
        {/*blog Section End*/}

        {/*Footer Section start*/}
        <div className="bg-light">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="copyright-section">
                  <p>2018- 19 Copyright &copy; powered by Company name</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*Footer Section End*/}
      </div>
      {/*blog Section end*/}
    </div>
  );
};

export default BlogLeftSide;
